module.exports = __webpack_public_path__ + "img/boucher_banner_mobile.f2fda06f.png";